// Module
var code = "<button type=\"submit\" ng-repeat=\"(key, value) in locales\" class=\"sidebar-box-cta flat round hollow white thin\" translate=\"lessons.stream.student_dashboard_boxes.{{key}}\" translate-values=\"{link: value, type: key}\" ng-click=\"onClick(value, key)\" name=\"admissions_info_box_link\"></button>";
// Exports
export default code;